import {RegistrarStudentTab} from "sections/academics/student/AcademicsStudent"
import {ADMISSION_STUDENT_TABS} from "sections/Admission/AdmissionStudent/AdmissionStudent"
import {AdmissionStudentAdmissionSubtab} from "sections/Admission/AdmissionStudent/parts"
import {FinancialAidStudentTabs} from "sections/FinancialAid/FinancialAidStudent/FinancialAidStudent"
import {FinAidStudentFinAidSubtab} from "sections/FinancialAid/FinancialAidStudent/parts/FinancialAidStudentTab/FinancialAidStudentTab"
import {StudentServicesStudentTab} from "sections/StudentServices/StudentServicesStudent/StudentServicesStudent"
import {BaseDepartmentId} from "types/departments"
import {Permissions, PermissionUserType} from "types/permission"

export function getPermissionsByDepartment(departmentId: number): PermissionUserType {
    switch (departmentId) {
        case BaseDepartmentId.Academics:
            return {staff: [Permissions.Staff.Settings.Modules.Academics.Edit]}
        case BaseDepartmentId.Admissions:
            return {staff: [Permissions.Staff.Settings.Modules.Admissions.Edit]}
        case BaseDepartmentId.CareerServices:
            return {staff: [Permissions.Staff.Settings.Modules.CareerServices.Edit]}
        case BaseDepartmentId.FinancialAid:
            return {staff: [Permissions.Staff.Settings.Modules.FinancialAid.Edit]}
        case BaseDepartmentId.StudentAccount:
            return {staff: [Permissions.Staff.Settings.Modules.StudentAccount.Edit]}
        case BaseDepartmentId.StudentServices:
            return {staff: [Permissions.Staff.Settings.Modules.StudentServices.Edit]}
        default:
            return {staff: []}
    }
}

export function getChecklistUrl(departmentId: number, studentProfileId: number): string {
    let url = "#"
    switch (departmentId) {
        case BaseDepartmentId.Admissions:
            url = `/admissions/student/${studentProfileId}?tab=${ADMISSION_STUDENT_TABS.ADMISSIONS}&subtab=${AdmissionStudentAdmissionSubtab.Checklist}`
            break
        case BaseDepartmentId.FinancialAid:
            url = `/financial-aid/student/${studentProfileId}?tab=${FinancialAidStudentTabs.FinancialAid}&subtab=${FinAidStudentFinAidSubtab.Checklist}`
            break
        case BaseDepartmentId.Academics:
            url = `/academics/registrar/student/${studentProfileId}?tab=${RegistrarStudentTab.Workspace}`
            break
        case BaseDepartmentId.AcademicAffair:
            url = `/academic-affairs/student/${studentProfileId}?tab=${StudentServicesStudentTab.Home}&departmentId=${BaseDepartmentId.AcademicAffair}`
            break
        case BaseDepartmentId.StudentServices:
            url = `/student-services/student/${studentProfileId}?tab=${StudentServicesStudentTab.Home}&departmentId=${BaseDepartmentId.StudentServices}`
            break
    }

    return url
}
